'use strict';

var $ = require('jquery');

// Constructor
var Debug = function() {
  $('.debug__toggle').on('click', function (e) {
      e.preventDefault();
      $(this).parent().toggleClass('visible');
  })
};

module.exports = Debug;
